import { SQLiteDBConnection } from '@capacitor-community/sqlite';

import { PejConflictError } from '@common-lib';

import { SqliteDatabase } from './sqlite-database';

export class PrintedOrdersRepository extends SqliteDatabase {
  constructor() {
    super('printed_orders_db', 1);
  }

  public async addOrder(orderId: string): Promise<void> {
    const insertQuery = `
      INSERT INTO printed_orders (order_id, printed_at)
      VALUES (?, ?);
    `;

    try {
      await this.withConnection(async (db) => {
        await db.run(insertQuery, [orderId, Date.now()]);
        await this.persistChanges();
      });
    } catch (error) {
      if (
        Error.isError(error) &&
        error.message.includes('UNIQUE constraint failed')
      ) {
        throw new PejConflictError(`Order ${orderId} has already been printed`);
      }

      throw error;
    }
  }

  public async isOrderPrinted(orderId: string): Promise<boolean> {
    const selectQuery = `
      SELECT COUNT(*) as count FROM printed_orders WHERE order_id = ?;
    `;

    return this.withConnection(async (db) => {
      const result = await db.query(selectQuery, [orderId]);

      return result.values?.[0].count === 1;
    });
  }

  public async cleanUpOldOrders(olderThan: number): Promise<void> {
    const deleteQuery = `
      DELETE FROM printed_orders WHERE printed_at < ?;
    `;

    await this.withConnection(async (db) => {
      await db.run(deleteQuery, [olderThan]);
      await this.persistChanges();
    });
  }

  protected async onInitTables(
    dbConnection: SQLiteDBConnection,
  ): Promise<void> {
    const createTableQuery = `
      CREATE TABLE IF NOT EXISTS printed_orders (
        order_id TEXT PRIMARY KEY NOT NULL,
        printed_at INTEGER NOT NULL
      );
    `;

    await dbConnection.execute(createTableQuery);
  }
}
